import { render, staticRenderFns } from "./referral_program_types.vue?vue&type=template&id=46479ea2&scoped=true&"
import script from "./referral_program_types.vue?vue&type=script&lang=js&"
export * from "./referral_program_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46479ea2",
  null
  
)

export default component.exports